import React from "react";

import {
  currencyFormatter,
  noDecimalNumberFormatter,
} from "@intelligems/ig-graphs/data-formatters";
import { IgTypography } from "@intelligems/ig-theme";
import { capitalizeFirstLetter } from "@intelligems/ig-utils";
import { Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import { useConfiguration } from "@src/api/configurations/use-configuration";

interface NewExperienceOverviewMetricsProps {
  experienceTotals: {
    visitors: number;
    orders: number | null;
    revenue: number | null;
  };
  isDataLoading: boolean;
}

const getFormattedData = (
  dataKey: string,
  value: number,
  storeCurrencyConfig: { code: string; locale: string }
) => {
  if (dataKey === "revenue") {
    return currencyFormatter(value, false, storeCurrencyConfig, false);
  } else if (dataKey === "visitors") {
    return noDecimalNumberFormatter(value, false, storeCurrencyConfig);
  } else {
    return noDecimalNumberFormatter(value, false, storeCurrencyConfig);
  }
};
export const ExperienceOverviewMetrics = ({
  experienceTotals,
  isDataLoading,
}: NewExperienceOverviewMetricsProps) => {
  const storeCurrencyConfig = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");
  return (
    <Grid
      container
      justifyContent={"flex-end"}
      alignItems={"center"}
      columnSpacing={3.75}
      wrap={"nowrap"}
    >
      {Object.keys(experienceTotals).map((key, index) => {
        const formattedValue = getFormattedData(
          key,
          experienceTotals[key],
          storeCurrencyConfig!.value
        );

        return (
          <Grid key={index}>
            <Stack spacing={0} direction={"column"}>
              <Grid>
                <IgTypography variant={"body2"}>
                  {capitalizeFirstLetter(key)}
                </IgTypography>
              </Grid>
              <Grid>
                <IgTypography variant={"body2"}>
                  {isDataLoading ? (
                    <Skeleton
                      variant="rectangular"
                      sx={{ borderRadius: "5px" }}
                      height={21}
                    />
                  ) : (
                    formattedValue
                  )}
                </IgTypography>
              </Grid>
            </Stack>
          </Grid>
        );
      })}
    </Grid>
  );
};
